import script from "./SignatureCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignatureCanvas.vue?vue&type=script&setup=true&lang=ts"

import "./SignatureCanvas.vue?vue&type=style&index=0&id=bc87828e&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc87828e"]])

export default __exports__